import UpgradePage from "./upgrade.page";

export default UpgradePage;
